import NotificacionAdapter from '../adapters/Notificacion.adapter'

export default class UpdateNotificationUsecase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idNotificacion, notificacion, perfil) {
    try {
      const payload = NotificacionAdapter.toDto(notificacion, 'update', perfil)
      const notificacionUpdated = await this.#repository.update(idNotificacion, payload, perfil)
      return notificacionUpdated
    } catch (error) {
      console.error('Error en UpdateNotificationUsecase.execute:', error)
      throw new Error('No fue posible actualizar la notificación.')
    }
  }
}
